<footer>

  <div class="links boxShadow">
    <a mat-button (click)="downloadHelp()">{{'SID_Help' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "SIDEBAR"}}</a>

    <a mat-button
      (click)="downloadAboutUs()">{{'SID_AboutUs' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "SIDEBAR"}}</a>

    <a mat-button
      (click)="downloadDataProtectionAndLegalNotice()">{{'SID_DataProtectionAndLegalNotice' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "SIDEBAR"}}</a>

    <a mat-button
      (click)="downloadDataProtection()">{{'SID_DataProtection' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "SIDEBAR"}}</a>

    <a mat-button
      (click)="downloadTermsOfUse()">{{'SID_TermsOfUse' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "SIDEBAR"}}</a>
  </div>

  <summary>
    <span>{{"PRTL_VRSN" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}} {{Version}}</span>    
    <span [innerHTML]="FooterProvder"></span>
    <span>{{"ApplicationName" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</span>
  </summary>

</footer>